import ConfigService from './Config';
import BaseService from './Base';

class Attachments extends BaseService {
  static endpoint = 'api/2.0/attachments/';

  static async create(data, skipLoading) {
    const url = ConfigService.generateURL(this.endpoint);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const fd = new FormData();
      fd.append('file', data[0]);
      fd.append('name', data[0].name);
      const response = await window.fetch(url, {
        method: 'POST',
        body: fd,
        headers: {
          'Authorization': 'jwt ' + localStorage.getItem('jwt_token'),
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    }
    catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  };
}

export default Attachments;